// extracted by mini-css-extract-plugin
export var deleteModal = "_fm-0";